import classNames from 'classnames';
import React from 'react';
interface ADSwitchButtonProps {
  isSaleAD: boolean;
  setisSaleAD: (isSaleAD: boolean) => void;
}
const ADSwitchButton = ({isSaleAD, setisSaleAD}: ADSwitchButtonProps) => {
  return (
    <div className="flex w-full  p-2 sticky top-0 z-10 bg-white">
      <button
        className="w-[50%] gap-4 pt-6 flex flex-col  items-center justify-center"
        onClick={() => setisSaleAD(false)}
      >
        <span
          className={classNames('', {
            'text-gray-5': isSaleAD,
            'text-primary': !isSaleAD,
          })}
        >
          آگهی‌های فروش
        </span>
        <div
          className={classNames('w-full    px-2', {
            'border-gray-5 border-[1px]': isSaleAD,
            'border-primary rounded border-2': !isSaleAD,
          })}
        />
      </button>
      <button
        className="w-[50%] gap-4 pt-6 flex flex-col items-center justify-center"
        onClick={() => setisSaleAD(true)}
      >
        <span
          className={classNames('', {
            'text-gray-5': !isSaleAD,
            'text-primary': isSaleAD,
          })}
        >
          آگهی‌های خرید
        </span>
        <div
          className={classNames('w-full    px-2', {
            'border-gray-5 border-[1px]': !isSaleAD,
            'border-primary rounded border-2': isSaleAD,
          })}
        />
      </button>
    </div>
  );
};

export default ADSwitchButton;
